import React, { useEffect, useState } from "react";
import { Insurance } from "../MotorInsuranceComponent/Insurance";
import { Faq } from "component/common/FraudDetails";
import { HomeServiceCard } from "component/HomePage/LandingComponent";
import { ExtensionCard } from "../MotorInsuranceComponent";
import "./style.scss";
import { MotorServicesData } from "../MotorInsuranceComponent/schema/MotorServicesData";
import { MotorProductCard } from "../MotorInsuranceComponent";
import { TwuniyaAppAdvert } from "component/common/TwuniyaAppAdvert";
import { CommonTable } from "component/common/CommonTable";
import xCircle from "assets/svg/orangeCloseIcon.svg";
import { ProductAndServicesCard } from "component/common/ProductAndServicesCard";
import { useTranslation } from "react-i18next";
import holdCar from "assets/svg/holdCar.svg";
import perkIcon1 from "assets/svg/perkIcons/perksIcon1.svg";
import perkIcon12 from "assets/svg/perkIcons/perksIcon12.svg";
import perkIcon5 from "assets/svg/perkIcons/perksIcon5.svg";
import perkIcon13 from "assets/svg/perkIcons/perksIcon13.svg";
import perkIcon6 from "assets/svg/perkIcons/perksIcon6.svg";
import perkIcon2 from "assets/svg/perkIcons/perksIcon2.svg";
import perkIcon7 from "assets/svg/perkIcons/perksIcon7.svg";
import perkIcon8 from "assets/svg/perkIcons/perksIcon8.svg";
import perkIcon9 from "assets/svg/perkIcons/perksIcon9.svg";
import perkIcon10 from "assets/svg/perkIcons/perksIcon10.svg";
import perkIcon14 from "assets/svg/perkIcons/perksIcon14.svg";
import perkIcon3 from "assets/svg/perkIcons/perksIcon3.svg";
import orangePerkTick from "assets/svg/orangePerkTick.svg";
import tickMark from "assets/svg/tickMark.svg";
import plus from "assets/svg/pluscircle.svg";
import engine from "assets/svg/breakDownIcons/engine.svg";
import gear from "assets/svg/breakDownIcons/gearbox.svg";
import differential from "assets/svg/breakDownIcons/differential.svg";
import turbo from "assets/svg/breakDownIcons/turbo.svg";
import ManagementSystem from "assets/svg/breakDownIcons/ManagementSystem.svg";
import prop from "assets/svg/breakDownIcons/propShaft.svg";
import steer from "assets/svg/breakDownIcons/steer.svg";
import wheelBearing from "assets/svg/breakDownIcons/wheelBearing.svg";
import breakSystem from "assets/svg/breakDownIcons/break.svg";
import fuel from "assets/svg/breakDownIcons/fuelSystem.svg";
import electricComponents from "assets/svg/breakDownIcons/elcetricComponents.svg";
import ElectricalIgnition from "assets/svg/breakDownIcons/ElectricalIgnition.svg";
import suspension from "assets/svg/breakDownIcons/suspension.svg";
import cylinder from "assets/svg/breakDownIcons/cylinder.svg";
import Radiator from "assets/svg/breakDownIcons/Radiator.svg";
import AirConditioner from "assets/svg/breakDownIcons/AirConditioner.svg";
import Overheating from "assets/svg/breakDownIcons/Overheating.svg";
import CambeltFailure from "assets/svg/breakDownIcons/CambeltFailure.svg";
import Clutch from "assets/svg/breakDownIcons/Clutch.svg";
import ElectricSunroof from "assets/svg/breakDownIcons/ElectricSunroof.svg";
import xOrangeCircle from "assets/svg/orangeCloseIcon.svg";
import catalog from "../../../assets/svg/motor/catalog.svg";
import { GenericButton } from "../../common/Buttons/GenericButton";
import { LandingSiteFilesLink } from "../../../helpers/constant";

export const MotorInsurancepage = () => {
  const { i18n, t } = useTranslation();
  const [faq, setFaq] = useState(null);
  useEffect(() => {
    if (faq != null && faq == "faq") {
      const section = document.querySelector("#faqsection");
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [faq]);

  function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    var tab = getParameterByName("to");
    console.log(tab);
    if (tab) {
      setFaq(tab);
    }
  }, []);

  const faqCategoryDataMotor = [
    {
      id: 0,
      question: t("motorPageData.motorPageFaqs.question1"),
      answer: t("motorPageData.motorPageFaqs.answer1"),
    },
    {
      id: 1,
      question: t("motorPageData.motorPageFaqs.question2"),
      answer: t("motorPageData.motorPageFaqs.answer2"),
    },
    {
      id: 2,
      question: t("motorPageData.motorPageFaqs.question3"),
      answer: t("motorPageData.motorPageFaqs.answer3"),
    },
    {
      id: 3,
      question: t("motorPageData.motorPageFaqs.question4"),
      answer: t("motorPageData.motorPageFaqs.answer4"),
    },
    {
      id: 4,
      question: t("motorPageData.motorPageFaqs.question5"),
      answer: t("motorPageData.motorPageFaqs.answer5"),
    },
    {
      id: 5,
      question: t("motorPageData.motorPageFaqs.question6"),
      answer: t("motorPageData.motorPageFaqs.answer6"),
    },
    {
      id: 6,
      question: t("motorPageData.motorPageFaqs.question7"),
      answer: t("motorPageData.motorPageFaqs.answer7"),
    },
  ];

  const headerPerkData = [
    {
      id: 0,
      mainClass: "customHeaderOne",
      baseClassOne: "ContainerComponentOne",
      baseClassTwo: "ContainerComponentTwo",
      paraClass: "fs-24 fw-800 pl-lg-5 pl-3 pr-lg-5 pr-3 headerTitleOne",
      paraTitle: t("motorPageData.plansData.coversAndBenefits"),
      hideCellOne: true,
      showTip: "hideToolTip",
    },
    {
      id: 1,
      mainClass: "customHeaderTwo",
      baseClassOne: "ContainerGoldOne",
      baseClassTwo: null,
      paraClass: "fs-24 fw-800 headerTitleTwo m-0 pb-2",
      paraTitle: t("motorPageData.plansData.alshamal"),
      paraSubtitle: null,
      paraSubtitleNew: t("motorPageData.plansData.comprehensive"),
      paraSubtitleNewClass: "fs-14 fw-400 componentTwoSubTitleNew",
      btnLabel: t("motorPageData.plansData.buyNow"),
      hideSubClass: "hideSubClass",
      hideCellOne: false,
      needExtraContent: true,
    },
    {
      id: 2,
      mainClass: "customHeaderFour",
      baseClassOne: "ContainerBronzeOne",
      baseClassTwo: null,
      paraClass: "fs-24 fw-800 headerTitleFour m-0",
      paraTitle: t("motorPageData.plansData.sanadPlus"),
      paraSubtitleNew: t("motorPageData.plansData.thirdParty"),
      motorTxt: "Motor Flex",
      holdIcon: holdCar,
      motorClass: "fs-14 fw-400 motorText",
      paraSubtitleNewClass: "fs-14 fw-400 componentFourSubTitleNew",
      hideCellOne: false,
      needExtraContent: true,
      showTip: "hideToolTip",
    },
    {
      id: 3,
      mainClass: "customHeaderThree",
      baseClassOne: "ContainerSilverOne",
      baseClassTwo: null,
      paraClass: "fs-24 fw-800 headerTitleThree m-0",
      paraTitle: t("motorPageData.plansData.sanad"),
      paraSubtitleNew: t("motorPageData.plansData.thirdParty"),
      motorTxt: "Motor Flex",
      holdIcon: holdCar,
      motorClass: "fs-14 fw-400 motorText",
      paraSubtitleNewClass: "fs-14 fw-400 componentThreeSubTitleNew",
      hideCellOne: false,
      needExtraContent: true,
      showTip: "hideToolTip",
    }
  ];
  const tablePerkData = [
    {
      id: 0,
      tableDivider: "customContainerOne p-0",
      tableClass: "benifitContainer pl-lg-5 pl-3 pt-3",
      tableNoClass: "p-3",
      needBorder: true,
      txt: null,
      newText: [
        {
          id: 0,
          tableCellContent: t("motorPageData.plansData.planKey1"),
          tableCellContentNew: "",
          tableSubClass: "benifitContainer-top-borderThin pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: perkIcon1,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 1,
          tableCellContent: t("motorPageData.plansData.planKey2"),
          tableSubClass: "benifitContainer pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: perkIcon12,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 2,
          tableCellContent: t("motorPageData.plansData.planKey3"),
          tableSubClass: "benifitContainer pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: perkIcon5,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 3,
          tableCellContent: t("motorPageData.plansData.planKey4"),
          tableSubClass: "benifitContainer pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: perkIcon13,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 4,
          tableCellContent: t("motorPageData.plansData.planKey5"),
          tableSubClass: "benifitContainer pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: perkIcon13,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 5,
          tableCellContent: t("motorPageData.plansData.planKey6"),
          tableSubClass: "benifitContainer pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: perkIcon1,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 6,
          tableCellContent: t("motorPageData.plansData.planKey7"),
          tableSubClass: "benifitContainer pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: perkIcon6,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 7,
          tableCellContent: t("motorPageData.plansData.planKey8"),
          tableSubClass: "benifitContainer pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: perkIcon2,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 8,
          tableCellContent: t("motorPageData.plansData.planKey9"),
          tableSubClass: "benifitContainer pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: perkIcon7,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 9,
          tableCellContent: t("motorPageData.plansData.planKey10"),
          tableSubClass: "benifitContainer pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: perkIcon8,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 10,
          tableCellContent: t("motorPageData.plansData.planKey11"),
          tableSubClass: "benifitContainer pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: perkIcon9,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 11,
          tableCellContent: t("motorPageData.plansData.planKey12"),
          tableSubClass: "benifitContainer pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: perkIcon10,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 12,
          tableCellContent: t("motorPageData.plansData.planKey13"),
          tableSubClass: "benifitContainer-bottom-borderThin pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: perkIcon14,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 13,
          tableCellContent: t("motorPageData.plansData.planKey14"),
          tableSubClass: "benifitContainer-bottom-borderThin pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: perkIcon3,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
      ],
    },
    {
      id: 1,
      tableDivider: "customContainerTwo p-0",
      tableClass: "bestSellerContainer text-center pt-3",
      tableNoClass: "p-3",
      txt: null,
      newText: [
        {
          id: 0,
          tableCellContent: null,
          tableSubClass: "bestSellerContainer-top-borderThin text-center",
          needOnlyIcon: true,
          icon: orangePerkTick,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 1,
          tableCellContent: null,
          tableSubClass: "bestSellerContainer text-center",
          needOnlyIcon: true,
          icon: orangePerkTick,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 2,
          tableCellContent: null,
          tableSubClass: "bestSellerContainer text-center",
          needOnlyIcon: true,
          icon: orangePerkTick,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 3,
          tableCellContent: null,
          tableSubClass: "bestSellerContainer text-center",
          needOnlyIcon: true,
          icon: orangePerkTick,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 4,
          tableCellContent: null,
          tableSubClass: "bestSellerContainer text-center",
          needOnlyIcon: true,
          icon: orangePerkTick,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 5,
          tableCellContent: null,
          tableSubClass: "bestSellerContainer text-center",
          needOnlyIcon: true,
          icon: orangePerkTick,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 6,
          tableCellContent: null,
          tableSubClass: "bestSellerContainer text-center",
          needOnlyIcon: true,
          icon: orangePerkTick,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 7,
          tableCellContent: null,
          tableSubClass: "bestSellerContainer text-center",
          needOnlyIcon: true,
          icon: orangePerkTick,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 8,
          tableCellContent: null,
          tableSubClass: "bestSellerContainer text-center",
          needOnlyIcon: true,
          icon: orangePerkTick,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 9,
          tableCellContent: null,
          tableSubClass: "bestSellerContainer text-center",
          needOnlyIcon: true,
          icon: orangePerkTick,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 10,
          tableCellContent: null,
          tableSubClass: "bestSellerContainer text-center",
          needOnlyIcon: true,
          icon: orangePerkTick,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 11,
          tableCellContent: null,
          tableSubClass: "bestSellerContainer text-center",
          needOnlyIcon: true,
          icon: orangePerkTick,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 12,
          tableCellContent: null,
          tableSubClass: "bestSellerContainer text-center",
          needOnlyIcon: true,
          icon: orangePerkTick,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 13,
          tableCellContent: null,
          tableSubClass: "bestSeller-bottom-Container text-center",
          needOnlyIcon: true,
          icon: orangePerkTick,
          iconClass: "img-fluid xCircleIcon",
        },
      ],
    },
    {
      id: 2,
      tableDivider: "customContainerFour p-0",
      tableClass: "sanadPlusContainer text-center",
      tableNoClass: "p-3",
      txt: null,
      newText: [
        {
          id: 0,
          tableCellContent: t("motorPageData.plansData.upto10k"),
          tableSubClass: "sanadPlusContainer-top-borderThin text-center",
          needOnlyIcon: true,
        },
        {
          id: 1,
          tableCellContent: null,
          tableSubClass: "sanadPlusContainer text-center",
          icon: tickMark,
          needOnlyIcon: true,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 2,
          tableCellContent: null,
          tableSubClass: "sanadPlusContainer text-center",
          icon: xCircle,
          needOnlyIcon: true,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 3,
          tableCellContent: null,
          tableSubClass: "sanadPlusContainer text-center",
          icon: xCircle,
          needOnlyIcon: true,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 4,
          tableCellContent: null,
          tableSubClass: "sanadPlusContainer text-center",
          icon: xCircle,
          needOnlyIcon: true,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 5,
          tableCellContent: null,
          tableSubClass: "sanadPlusContainer text-center",
          icon: tickMark,
          needOnlyIcon: true,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 6,
          tableCellContent: null,
          tableSubClass: "sanadPlusContainer text-center",
          icon: tickMark,
          needOnlyIcon: true,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 7,
          tableCellContent: null,
          tableSubClass: "sanadPlusContainer text-center",
          icon: plus,
          needOnlyIcon: true,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 8,
          tableCellContent: null,
          tableSubClass: "sanadPlusContainer text-center",
          icon: plus,
          needOnlyIcon: true,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 9,
          tableCellContent: null,
          tableSubClass: "sanadPlusContainer text-center",
          icon: plus,
          needOnlyIcon: true,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 10,
          tableCellContent: null,
          tableSubClass: "sanadPlusContainer text-center",
          icon: plus,
          needOnlyIcon: true,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 11,
          tableCellContent: null,
          tableSubClass: "sanadPlusContainer text-center",
          icon: plus,
          needOnlyIcon: true,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 12,
          tableCellContent: null,
          tableSubClass: "sanadPlusContainer text-center",
          icon: plus,
          needOnlyIcon: true,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 13,
          tableCellContent: null,
          tableSubClass: "sanadPlus-bottom-Container text-center",
          icon: plus,
          needOnlyIcon: true,
          iconClass: "img-fluid xCircleIcon",
        },
      ],
    },
    {
      id: 3,
      tableDivider: "customContainerThree p-0",
      tableClass: "sanadContainer text-center pt-3",
      tableNoClass: "p-3",
      txt: null,
      newText: [
        {
          id: 0,
          tableCellContent: null,
          tableSubClass: "sanadContainer-top-borderThin text-center",
          needOnlyIcon: true,
          icon: xCircle,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 1,
          tableCellContent: null,
          tableSubClass: "sanadContainer text-center",
          needOnlyIcon: true,
          icon: tickMark,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 2,
          tableCellContent: null,
          tableSubClass: "sanadContainer text-center",
          needOnlyIcon: true,
          icon: xCircle,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 3,
          tableCellContent: null,
          tableSubClass: "sanadContainer text-center",
          needOnlyIcon: true,
          icon: xCircle,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 4,
          tableCellContent: null,
          tableSubClass: "sanadContainer text-center",
          needOnlyIcon: true,
          icon: xCircle,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 5,
          tableCellContent: null,
          tableSubClass: "sanadContainer text-center",
          needOnlyIcon: true,
          icon: tickMark,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 6,
          tableCellContent: null,
          tableSubClass: "sanadContainer text-center",
          needOnlyIcon: true,
          icon: tickMark,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 7,
          tableCellContent: null,
          tableSubClass: "sanadContainer text-center",
          needOnlyIcon: true,
          icon: plus,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 8,
          tableCellContent: null,
          tableSubClass: "sanadContainer text-center",
          needOnlyIcon: true,
          icon: plus,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 9,
          tableCellContent: null,
          tableSubClass: "sanadContainer text-center",
          needOnlyIcon: true,
          icon: plus,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 10,
          tableCellContent: null,
          tableSubClass: "sanadContainer text-center",
          needOnlyIcon: true,
          icon: plus,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 11,
          tableCellContent: null,
          tableSubClass: "sanadContainer text-center",
          needOnlyIcon: true,
          icon: plus,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 12,
          tableCellContent: null,
          tableSubClass: "sanadContainer text-center",
          needOnlyIcon: true,
          icon: plus,
          iconClass: "img-fluid xCircleIcon",
        },
        {
          id: 13,
          tableCellContent: null,
          tableSubClass: "sanad-bottom-Container text-center",
          needOnlyIcon: true,
          icon: plus,
          iconClass: "img-fluid xCircleIcon",
        },
      ],
    }
  ];

  const headerBreakDownData = [
    {
      id: 0,
      mainClass: "customHeaderOne",
      baseClassOne: "ContainerComponentOne",
      baseClassTwo: "ContainerComponentTwo",
      paraClass: "fs-24 fw-800 pl-lg-5 pl-3 pr-lg-5 pr-3 headerTitleOne",
      paraTitle: t("motorPageData.mechanicalBreak.headerText.firstTitle"),
      hideCellOne: true,
      showTip: "hideToolTip",
    },
    {
      id: 1,
      mainClass: "customHeaderTwo",
      baseClassOne: "ContainerGoldOne",
      baseClassTwo: null,
      paraClass: "fs-24 fw-800 headerTitleTwo",
      paraTitle: t("motorPageData.mechanicalBreak.headerText.gold"),
      btnLabel: t("motorPageData.mechanicalBreak.headerText.orderNow"),
      hideCellOne: false,
      showTip: "hideToolTip",
    },
    {
      id: 2,
      mainClass: "customHeaderThree",
      baseClassOne: "ContainerSilverOne",
      baseClassTwo: null,
      paraClass: "fs-24 fw-800 headerTitleThree",
      paraTitle: t("motorPageData.mechanicalBreak.headerText.silver"),
      hideCellOne: false,
      showTip: "hideToolTip",
    },
    {
      id: 3,
      mainClass: "customHeaderFour",
      baseClassOne: "ContainerBronzeOne",
      baseClassTwo: null,
      paraClass: "fs-24 fw-800 headerTitleFour",
      paraTitle: t("motorPageData.mechanicalBreak.headerText.bronze"),
      hideCellOne: false,
      showTip: "hideToolTip",
    },
  ];
  const tableBreakDownData = [
    {
      id: 0,
      tableDivider: "customContainerOne p-0",
      tableClass: "benifitContainer pl-lg-5 pl-3 pt-3 pr-lg-5 pr-3",
      tableNoClass: "p-3",
      needBorder: true,
      txt: null,
      newText: [
        {
          id: 0,
          tableCellContent: t("motorPageData.mechanicalBreak.breakService1"),
          tableSubClass: "benifitContainer-top-borderThin-BreakDown pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: engine,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 1,
          tableCellContent: t("motorPageData.mechanicalBreak.breakService2"),
          tableSubClass: "benifitContainer pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: gear,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 2,
          tableCellContent: t("motorPageData.mechanicalBreak.breakService3"),
          tableSubClass: "benifitContainer pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: differential,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 3,
          tableCellContent: t("motorPageData.mechanicalBreak.breakService4"),
          tableSubClass: "benifitContainer pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: turbo,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 4,
          tableCellContent: t("motorPageData.mechanicalBreak.breakService5"),
          tableSubClass: "benifitContainer pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: ManagementSystem,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 5,
          tableCellContent: t("motorPageData.mechanicalBreak.breakService6"),
          tableSubClass: "benifitContainer pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: prop,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 6,
          tableCellContent: t("motorPageData.mechanicalBreak.breakService7"),
          tableSubClass: "benifitContainer pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: steer,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 7,
          tableCellContent: t("motorPageData.mechanicalBreak.breakService8"),
          tableSubClass: "benifitContainer pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: wheelBearing,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 8,
          tableCellContent: t("motorPageData.mechanicalBreak.breakService9"),
          tableSubClass: "benifitContainer pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: breakSystem,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 9,
          tableCellContent: t("motorPageData.mechanicalBreak.breakService10"),
          tableSubClass: "benifitContainer pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: fuel,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 10,
          tableCellContent: t("motorPageData.mechanicalBreak.breakService11"),
          tableSubClass: "benifitContainer pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: electricComponents,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 11,
          tableCellContent: t("motorPageData.mechanicalBreak.breakService12"),
          tableSubClass: "benifitContainer pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: ElectricalIgnition,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 12,
          tableCellContent: t("motorPageData.mechanicalBreak.breakService13"),
          tableSubClass: "benifitContainer pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: suspension,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 13,
          tableCellContent: t("motorPageData.mechanicalBreak.breakService14"),
          tableSubClass: "benifitContainer-bottom-borderThin pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: cylinder,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 14,
          tableCellContent: t("motorPageData.mechanicalBreak.breakService15"),
          tableSubClass: "benifitContainer pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: Radiator,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 15,
          tableCellContent: t("motorPageData.mechanicalBreak.breakService16"),
          tableSubClass: "benifitContainer-bottom-borderThin pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: AirConditioner,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 16,
          tableCellContent: t("motorPageData.mechanicalBreak.breakService17"),
          tableSubClass: "benifitContainer-bottom-borderThin pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: Overheating,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 17,
          tableCellContent: t("motorPageData.mechanicalBreak.breakService18"),
          tableSubClass: "benifitContainer-bottom-borderThin pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: CambeltFailure,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 18,
          tableCellContent: t("motorPageData.mechanicalBreak.breakService19"),
          tableSubClass: "benifitContainer-bottom-borderThin pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: Clutch,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 19,
          tableCellContent: t("motorPageData.mechanicalBreak.breakService20"),
          tableSubClass: "benifitContainer-bottom-borderThin pl-lg-5 pl-3 pr-lg-5 pr-3",
          icon: ElectricSunroof,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
      ],
    },
    {
      id: 1,
      tableDivider: "customContainerTwo p-0",
      tableClass: "bestSellerContainer text-center pt-3",
      tableNoClass: "p-3",
      txt: null,
      newText: [
        {
          id: 0,
          tableCellContent: t("motorPageData.mechanicalBreak.price20k"),
          tableSubClass: "bestSellerContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 1,
          tableCellContent: t("motorPageData.mechanicalBreak.price10k"),
          tableSubClass: "bestSellerContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 2,
          tableCellContent: t("motorPageData.mechanicalBreak.price10k"),
          tableSubClass: "bestSellerContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 3,
          tableCellContent: t("motorPageData.mechanicalBreak.price5k"),
          tableSubClass: "bestSellerContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 3.5,
          tableCellContent: t("motorPageData.mechanicalBreak.price5k"),
          tableSubClass: "bestSellerContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 4,
          tableCellContent: t("motorPageData.mechanicalBreak.price4k"),
          tableSubClass: "bestSellerContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 5,
          tableCellContent: t("motorPageData.mechanicalBreak.price4k"),
          tableSubClass: "bestSellerContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 6,
          tableCellContent: t("motorPageData.mechanicalBreak.price4k"),
          tableSubClass: "bestSellerContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 7,
          tableCellContent: t("motorPageData.mechanicalBreak.price4k"),
          tableSubClass: "bestSellerContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 8,
          tableCellContent: t("motorPageData.mechanicalBreak.price4k"),
          tableSubClass: "bestSellerContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 9,
          tableCellContent: t("motorPageData.mechanicalBreak.price4k"),
          tableSubClass: "bestSellerContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 10,
          tableCellContent: t("motorPageData.mechanicalBreak.price4k"),
          tableSubClass: "bestSellerContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 11,
          tableCellContent: t("motorPageData.mechanicalBreak.price4k"),
          tableSubClass: "bestSellerContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 12,
          tableCellContent: t("motorPageData.mechanicalBreak.price4k"),
          tableSubClass: "bestSeller-bottom-Container text-center",
          needOnlyIcon: true,
        },
        {
          id: 13,
          tableCellContent: t("motorPageData.mechanicalBreak.price4k"),
          tableSubClass: "bestSeller-bottom-Container text-center",
          needOnlyIcon: true,
        },
        {
          id: 14,
          tableCellContent: t("motorPageData.mechanicalBreak.price4k"),
          tableSubClass: "bestSeller-bottom-Container text-center",
          needOnlyIcon: true,
        },
        {
          id: 15,
          tableCellContent: t("motorPageData.mechanicalBreak.price4k"),
          tableSubClass: "bestSeller-bottom-Container text-center",
          needOnlyIcon: true,
        },
        {
          id: 16,
          tableCellContent: t("motorPageData.mechanicalBreak.price4k"),
          tableSubClass: "bestSeller-bottom-Container text-center",
          needOnlyIcon: true,
        },
        {
          id: 17,
          tableCellContent: t("motorPageData.mechanicalBreak.price4k"),
          tableSubClass: "bestSeller-bottom-Container text-center",
          needOnlyIcon: true,
        },
        {
          id: 18,
          tableCellContent: t("motorPageData.mechanicalBreak.price4k"),
          tableSubClass: "bestSeller-bottom-Container text-center",
          needOnlyIcon: true,
        },
      ],
    },
    {
      id: 2,
      tableDivider: "customContainerThree p-0",
      tableClass: "sanadContainer text-center pt-3",
      tableNoClass: "p-3",
      txt: null,
      newText: [
        {
          id: 0,
          tableCellContent: t("motorPageData.mechanicalBreak.price20k"),
          tableSubClass: "sanadContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 1,
          tableCellContent: t("motorPageData.mechanicalBreak.price10k"),
          tableSubClass: "sanadContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 2,
          tableCellContent: t("motorPageData.mechanicalBreak.price10k"),
          tableSubClass: "sanadContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 3,
          tableCellContent: t("motorPageData.mechanicalBreak.price5k"),
          tableSubClass: "sanadContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 3.5,
          tableCellContent: t("motorPageData.mechanicalBreak.price5k"),
          tableSubClass: "sanadContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 4,
          tableCellContent: t("motorPageData.mechanicalBreak.price4k"),
          tableSubClass: "sanadContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 5,
          tableCellContent: t("motorPageData.mechanicalBreak.price4k"),
          tableSubClass: "sanadContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 6,
          tableCellContent: t("motorPageData.mechanicalBreak.price4k"),
          tableSubClass: "sanadContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 7,
          tableCellContent: t("motorPageData.mechanicalBreak.price4k"),
          tableSubClass: "sanadContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 8,
          tableCellContent: t("motorPageData.mechanicalBreak.price4k"),
          tableSubClass: "sanadContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 9,
          tableCellContent: t("motorPageData.mechanicalBreak.price4k"),
          tableSubClass: "sanadContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 10,
          tableCellContent: t("motorPageData.mechanicalBreak.price4k"),
          tableSubClass: "sanadContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 11,
          tableCellContent: t("motorPageData.mechanicalBreak.price4k"),
          tableSubClass: "sanadContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 12,
          tableCellContent: null,
          tableSubClass: "sanad-bottom-Container text-center",
          needOnlyIcon: true,
          iconClass: "img-fluid xCircleIcon",
          icon: xOrangeCircle,
        },
        {
          id: 13,
          tableCellContent: null,
          tableSubClass: "sanad-bottom-Container text-center",
          needOnlyIcon: true,
          iconClass: "img-fluid xCircleIcon",
          icon: xOrangeCircle,
        },
        {
          id: 14,
          tableCellContent: null,
          tableSubClass: "sanad-bottom-Container text-center",
          needOnlyIcon: true,
          iconClass: "img-fluid xCircleIcon",
          icon: xOrangeCircle,
        },
        {
          id: 15,
          tableCellContent: null,
          tableSubClass: "sanad-bottom-Container text-center",
          needOnlyIcon: true,
          iconClass: "img-fluid xCircleIcon",
          icon: xOrangeCircle,
        },
        {
          id: 16,
          tableCellContent: null,
          tableSubClass: "sanad-bottom-Container text-center",
          needOnlyIcon: true,
          iconClass: "img-fluid xCircleIcon",
          icon: xOrangeCircle,
        },
        {
          id: 17,
          tableCellContent: null,
          tableSubClass: "sanad-bottom-Container text-center",
          needOnlyIcon: true,
          iconClass: "img-fluid xCircleIcon",
          icon: xOrangeCircle,
        },
        {
          id: 18,
          tableCellContent: null,
          tableSubClass: "sanad-bottom-Container text-center",
          needOnlyIcon: true,
          iconClass: "img-fluid xCircleIcon",
          icon: xOrangeCircle,
        },
      ],
    },
    {
      id: 3,
      tableDivider: "customContainerFour p-0",
      tableClass: "sanadPlusContainer text-center pt-3",
      tableNoClass: "p-3",
      txt: null,
      newText: [
        {
          id: 0,
          tableCellContent: t("motorPageData.mechanicalBreak.price20k"),
          tableSubClass: "sanadPlusContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 1,
          tableCellContent: t("motorPageData.mechanicalBreak.price10k"),
          tableSubClass: "sanadPlusContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 2,
          tableCellContent: t("motorPageData.mechanicalBreak.price10k"),
          tableSubClass: "sanadPlusContainer text-center",
          needOnlyIcon: true,
        },
        {
          id: 3,
          tableCellContent: null,
          tableSubClass: "sanadPlusContainer text-center",
          icon: xOrangeCircle,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 3.5,
          tableCellContent: null,
          tableSubClass: "sanadPlusContainer text-center",
          icon: xOrangeCircle,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 4,
          tableCellContent: null,
          tableSubClass: "sanadPlusContainer text-center",
          icon: xOrangeCircle,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 5,
          tableCellContent: null,
          tableSubClass: "sanadPlusContainer text-center",
          icon: xOrangeCircle,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 6,
          tableCellContent: null,
          tableSubClass: "sanadPlusContainer text-center",
          icon: xOrangeCircle,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 7,
          tableCellContent: null,
          tableSubClass: "sanadPlusContainer text-center",
          icon: xOrangeCircle,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 8,
          tableCellContent: null,
          tableSubClass: "sanadPlusContainer text-center",
          icon: xOrangeCircle,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 9,
          tableCellContent: null,
          tableSubClass: "sanadPlusContainer text-center",
          icon: xOrangeCircle,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 10,
          tableCellContent: null,
          tableSubClass: "sanadPlusContainer text-center",
          icon: xOrangeCircle,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 11,
          tableCellContent: null,
          tableSubClass: "sanadPlusContainer text-center",
          icon: xOrangeCircle,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 12,
          tableCellContent: null,
          tableSubClass: "sanadPlus-bottom-Container text-center",
          icon: xOrangeCircle,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 13,
          tableCellContent: null,
          tableSubClass: "sanadPlus-bottom-Container text-center",
          icon: xOrangeCircle,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 14,
          tableCellContent: null,
          tableSubClass: "sanadPlus-bottom-Container text-center",
          icon: xOrangeCircle,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 15,
          tableCellContent: null,
          tableSubClass: "sanadPlus-bottom-Container text-center",
          icon: xOrangeCircle,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 16,
          tableCellContent: null,
          tableSubClass: "sanadPlus-bottom-Container text-center",
          icon: xOrangeCircle,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 17,
          tableCellContent: null,
          tableSubClass: "sanadPlus-bottom-Container text-center",
          icon: xOrangeCircle,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
        {
          id: 18,
          tableCellContent: null,
          tableSubClass: "sanadPlus-bottom-Container text-center",
          icon: xOrangeCircle,
          iconClass: "img-fluid xCircleIcon",
          needOnlyIcon: true,
        },
      ],
    },
  ];

  const downloadFile = () => {
    window.lmSMTObj.track(t("productCatalog"+"Clicked"));
    window.open(LandingSiteFilesLink.MechanicalBreakdownFile);
  };

  return (
    <React.Fragment>
      <div className="MotorInsuranceMainContainer">
        <Insurance />
        <MotorProductCard />
        <div className="row" id="motorPlans">
          <div className="col-12 pt-5">
            <p className="perkHeading fw-800 m-0">{t("motorPageData.plansData.title")}</p>
            <p className="perkPara fw-400 pb-2">{t("motorPageData.plansData.desc")}</p>
            <CommonTable headerData={headerPerkData} tableData={tablePerkData} />
          </div>
        </div>
        <ExtensionCard />
        <div className="row" id="motorFeature">
          <div className="col-12 pt-5">
            <p className="breakdownHeading fw-800 m-0">{t("motorPageData.mechanicalBreak.title")}</p>
            <p className="breakingPara fw-400 pb-2">{t("motorPageData.mechanicalBreak.desc")}</p>
            <div className="catalogue-button">
              <GenericButton
                label={t("productCatalog")}
                className="active justify-content-center custom-width"
                onClick={downloadFile}
              />
            </div>

            <CommonTable headerData={headerBreakDownData} tableData={tableBreakDownData} />
            <ul className="policy-text-wrapper">
              <li className="policy-item">{t("motorPageData.mechanicalBreak.shortPara1")}</li>
              <li className="policy-item">{t("motorPageData.mechanicalBreak.shortPara2")}</li>
            </ul>
          </div>
        </div>
        <div className="motor-faq-container">
          <div className="pb-3" id="motorService">
            <h3 className="surplush4 fs-36 fw-800 text-center faqTitle  pt-4 m-0">
              {t("motorPageData.valueAddedSection.title")}
            </h3>
            <p>
              {t("motorPageData.valueAddedSection.description")}
            </p>
            <HomeServiceCard header={false} HomeServicesData={MotorServicesData} pillNumber={1} />
          </div>
          <div id="faqsection"></div>
          <Faq faqData={faqCategoryDataMotor} viewAll={false} faqId="motorFaq" />
        </div>
        <TwuniyaAppAdvert />
        <ProductAndServicesCard />
        {/*<BottomSectionView/>*/}
      </div>
    </React.Fragment>
  );
};
